import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CustomIconService } from './services/custom-icon.service';
import { AuthService } from './services/auth.service';
import { ApiConfiguration } from './api/api-configuration';
import { EnvironmentLoaderService } from './services/environment-loader.service';
import { SignalrService } from './services/signalr.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { RoutingStateService } from './services/routing-state.service';
import { FejlDashboardService } from './components/fejl-dashboard/fejl-dashboard.service';
import { NotificationService } from './notifications/services/notification.service';
import { Subject } from 'rxjs';
import { Notification } from './notifications/models/notification-models';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  notification$: Subject<Notification> = this.notificationService.notify$;

  constructor(
    private customIconService: CustomIconService,
    private authService: AuthService,
    private api: ApiConfiguration,
    private environmentLoaderService: EnvironmentLoaderService,
    private signalR: SignalrService,
    private bnIdle: BnNgIdleService,
    private routingState: RoutingStateService,
    private fejlDashboardService: FejlDashboardService,
    private notificationService: NotificationService
  ) {
    this.customIconService.init();
    const baseUrl = this.environmentLoaderService.config.egisServiceBaseUrl;
    this.api.rootUrl = baseUrl;
    this.fejlDashboardService.init();
    this.routingState.loadRouting();
  }

  ngOnInit() {
    const sessionTimout = parseInt(this.environmentLoaderService.config.sessionTimeout, 10); // If not configured - don't enable session timeout.

    if (sessionTimout) {
      console.log('Enable session timeout with: ' + sessionTimout);
      this.bnIdle.startWatching(sessionTimout).subscribe((isTimedOut: boolean) => {
        if (isTimedOut) {
          console.log('Session expired');
          this.authService.logout();
        }
      });
    }

    this.signalR.startConnection();
    this.signalR.serviceordreCreatedListener();
    this.signalR.serviceordreChangedListener();
    this.signalR.serviceaftaleCreatedListener();
    this.signalR.serviceaftaleChangedListener();
    this.signalR.opfoelgningChangedListener();
    this.signalR.serviceafregningCreatedListener();
    this.signalR.excelCreatedListener();
    this.signalR.excelCreateFailedListener();
    this.signalR.excelUploadedListener();
    this.signalR.excelUploadFailedListener();
    this.signalR.fejlDashboardSummaryListener();
    this.signalR.updateServiceabonnementFailedListener();
    this.signalR.updateServiceabonnementUpdatedListener();
    this.signalR.serviceordreCancelledListener();
    this.signalR.serviceordreCancelFailedListener();
    this.signalR.serviceordreRejectedListener();
    this.signalR.serviceordreRejectionFailedListener();
    this.signalR.serviceaftalePriceCacheUpdatedListener();
    this.signalR.serviceaftalePriceCacheFailedListener();

    this.signalR.serviceordreCancelled$.subscribe((n) => this.notificationService.success(n));
    this.signalR.serviceordreCancelFailed$.subscribe((n) => this.notificationService.error(n));
    this.signalR.serviceordreRejected$.subscribe((n) => this.notificationService.success(n));
    this.signalR.serviceordreRejectionFailed$.subscribe((n) => this.notificationService.error(n));
  }
}
